import type { CheckboxOrientation, CheckboxOption } from '../model/form.types';

export const MIN_OPTIONS = 1;

export const CHECKBOX_DEFAULTS = {
  ORIENTATION: 'vertical' as CheckboxOrientation,
  LABEL_POSITION: 'top' as const,
  OPTIONS: [
    { id: '1', text: 'Opção 1' },
    { id: '2', text: 'Opção 2' },
  ] as CheckboxOption[],
} as const;
